import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { twigComponentsMap, components, refactoredComponentsMap } from '../lazySections';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Finds which componentKey should be used for the section template
 */
var getComponentName = function getComponentName(section) {
  var template = section.template || section.component;
  /**
   * `components` is the list with all new components as key, we try to get
   * from there first.
   */

  if (components[template]) {
    return template;
  }
  /**
   * If the template wasn't found in the new components list, try to get it
   * from the refactored components list
   */


  if (refactoredComponentsMap[template]) {
    return refactoredComponentsMap[template];
  }
  /**
   * In last case, fallback to trying to use the legacy twig keys
   */


  return twigComponentsMap[template];
};

var SectionRenderer = function SectionRenderer(_ref) {
  var section = _ref.section;

  if (section.hidden) {
    return null;
  }

  var Component = components[getComponentName(section)];
  /**
   * If we don't find the component we need to render, we should throw an error to avoid
   * rendering pages with missing sections
   */

  if (!Component) {
    throw new Error("Couldn't find the component to render ".concat(section.template || section.component, "."));
  }

  return /*#__PURE__*/_jsx(Component, _objectSpread({
    sectionId: section.id
  }, section.values), section.id);
};

export default SectionRenderer;